export const languageMiddleware = async (req) => {
  const userLocale = 'en'

  req.headers.set('Accept-Language', userLocale)

  return req
}